import { Injectable, inject } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';
import { MessagingCurrentContext, MessagingParticipant } from './messaging.models';

@Injectable({ providedIn: 'root' })
export class MessagingContextService {
  private readonly auth = inject(AuthService);

  getCurrentContext(): MessagingCurrentContext {
    const user = this.auth.user.getValue();
    const organizationId = user?.organizationId ?? user?.hospitalId ?? '';
    const participantId = user?.fhirResourceId ?? user?.userId ?? user?.id ?? '';

    if (!organizationId) {
      throw new Error('Messaging context missing organizationId for current user.');
    }

    if (!participantId) {
      throw new Error('Messaging context missing participantId for current user.');
    }

    return {
      organizationId,
      participantId,
      currentRole: user?.role,
      userDisplay: user?.display ?? user?.name ?? user?.email ?? participantId
    };
  }

  getCurrentParticipant(resourceType = 'Practitioner'): MessagingParticipant {
    const user = this.auth.user.getValue();
    const participantId = user?.fhirResourceId ?? user?.userId ?? user?.id ?? '';

    if (!participantId) {
      throw new Error('Messaging participantId is missing for current user.');
    }

    return {
      participantId,
      resourceType,
      resourceId: user?.fhirResourceId ?? user?.id ?? participantId,
      display: user?.display ?? user?.name ?? user?.email ?? participantId,
      roleName: user?.role,
      participantType: resourceType.toLowerCase()
    };
  }
}
